module.exports = __webpack_public_path__ + "static/twitter-6918db95c0f5675ee30e5f6f3445daa6.png";